<template>
  <div class="content">
    <div class="logo">
      <img
        src="@/assets/img/zhsw.png"
        alt=""
      />
    </div>
    <van-form
      @submit="onSubmit"
      class="form-main"
    >
      <van-field
        v-model.trim="username"
        name="用户名"
        type="number"
        placeholder="请输入手机号码"
        maxlength="11"
        :rules="[{ validator: checkPhone, required: true}]"
      />
      <van-field
        v-model.trim="code"
        name="验证码"
        maxlength="4"
        type="number"
        placeholder="请输入验证码"
        :rules="[{ required: true}]"
      >
        <template #button>
          <van-button
            class="code-btn"
            :style="{color:codeColor}"
            :disabled="whetherGetKeyCode"
            size="small"
            native-type="button"
            type="default"
            @click="getKeyCode"
          >{{whetherGetKeyCode ? codeTime+'S' : '获取验证码'}}</van-button>
        </template>
      </van-field>
      <van-field
        v-model.trim="company"
        name="单位全称"
        maxlength="20"
        placeholder="请输入单位全称"
        :rules="[{required: true}]"
      />
      <van-field
        v-model.trim="password"
        :type="isCheckPwd1 ? 'text' : 'password'"
        :right-icon="isCheckPwd1 ? 'eye-o' : 'closed-eye'"
        name="密码"
        placeholder="请设置密码，6-20位数字+英文"
        @click-right-icon="checkPwd"
        :rules="[{validator: checkPassword, required: true}]"
      >
      </van-field>
      <van-field
        v-model.trim="againPassword"
        :type="isCheckPwd2 ? 'text' : 'password'"
        :right-icon="isCheckPwd2 ? 'eye-o' : 'closed-eye'"
        name="再次输入密码"
        placeholder="请再次输入密码"
        @click-right-icon="checkPwd2"
        :rules="[{validator: checkAgainPassword,required: true}]"
      >
      </van-field>
      <div>
        <van-button
          round
          class="register-btn"
          block
          type="info"
          native-type="submit"
          :disabled="!checkbox"
        >下一步</van-button>
      </div>
      <van-field
        name="checkbox"
        class="check-box"
      >
        <template #input>
          <van-checkbox
            icon-size="13px"
            checked-color="#2DC660"
            v-model="checkbox"
            shape="square"
          />
          <span class="agreement1">已经阅读并同意</span>
          <span
            class="agreement2"
            @click="showProtocol = true"
          >《智惠水务商家管理中心用户协议》</span>
        </template>
      </van-field>
      <van-overlay
        :show="showProtocol"
        @click="showProtocol = false"
        :lock-scroll="false"
      >
        <div class="wrapper">
          <span v-html="protocolMain"></span>
        </div>
        <van-icon
          color="#fff"
          name="close"
          style="margin-top:30px;"
        />
      </van-overlay>
    </van-form>
    <!-- 登录弹窗 -->
    <van-overlay
      :show="showLogin"
      @click="showLogin = false"
    >
      <van-form
        validate-first
        @submit="onSubmitLogin"
        class="login-wrapper"
        @click.stop.native
      >
        <div class="login-title">手机号已注册，登录完善资料</div>
        <van-field
          v-model.trim="username"
          name="用户名"
          type="number"
          placeholder="请输入手机号码"
          maxlength="11"
          :rules="[{required: true}]"
          style="padding: 0.37333rem 0.42667rem"
        />
        <van-field
          v-model.trim="password"
          :type="isCheckPwd1 ? 'text' : 'password'"
          :right-icon="isCheckPwd1 ? 'eye-o' : 'closed-eye'"
          name="密码"
          placeholder="请输入密码"
          @click-right-icon="checkPwd"
          :rules="[{required: true}]"
          style="padding: 0.37333rem 0.42667rem"
        >
        </van-field>
        <div class="login-btn">
          <van-button
            text="取消"
            type="info"
            class="cancel"
            native-type="button"
            @click="showLogin = false"
          />
          <van-button
            text="确定登录"
            type="info"
            class="confirm"
            native-type="submit"
          />
        </div>
      </van-form>
    </van-overlay>
  </div>
</template>
<script>
import { verificationCode, InfoTwo, getActivityRuleContent, getMCipher, loginTwo } from "@/api/join";
export default {
  data() {
    return {
      username: "",
      code: "",
      company: "",
      password: "",
      againPassword: "",
      checkbox: false,
      isCheckPwd1: false, // 是否显示密码
      isCheckPwd2: false, // 是否显示二次输入的密码
      codeTime: 60, // 验证码倒计时
      codeColor: "#FFB14A",
      whetherGetKeyCode: false, // 是否可以再次获取验证码
      showProtocol: false, // 是否显示协议弹框
      protocolMain: "",    // 悦买内容协议
      showLogin: false
    };
  },
  created() {
    this.getActivityRuleContent();
  },
  methods: {
    // 登录
    onSubmitLogin() {
      loginTwo(`account=${this.username}&password=${this.$md5(this.password)}`).then((res) => {
        let code = res.appStatus.errorCode;
        if (code == 0 || code == 6) {
          // 审核成功或者审核中
          this.$router.push({
            name: "auditPublisher",
            params: {
              isAuditPass: code == 0 ? 1 : 2,
            },
          });
        } else if (code == 5) {
          // 未审核
          this.$router.push({
            name: "perfect",
            params: {
              isManager: res.content[0]["csId"] == 0 ? 0 : 1,
              perfectInfo: {
                telephone: this.username,
                company: res.content[0]['company'],
                sellerId: res.content[0]["sellerId"],
                sellerApplyId: res.content[0]["sellerApplyId"]
              }
            },
          });
        } else if (code == 7) {
          // 审核失败
          this.$router.push({
            name: "auditPublisher",
            params: {
              notPassTime: res.content[0].submitTime,
              isAuditPass: 3,
              notPassReason: res.content[0].cause,
              isManager: res.content[0]["csId"] == 0 ? 0 : 1,
              perfectInfo: res.content[0]
            },
          });
        }
      });
    },
    // 表单检测相关方法开始
    checkPhone(value) {
      if (typeof value !== "number" && isNaN(value)) {
        this.$toast("请输入数字");
        return false;
      } else if (value === "") {
        this.$toast("请输入手机号");
        return false;
      } else {
        return true;
      }
    },
    checkPassword(value) {
      const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
      if (value === "") {
        this.$toast("请输入密码");
        return false;
      } else if (!reg.test(value)) {
        // callback(new Error("输入的密码不符合格式要求，请重新设置"));
        this.$toast("输入的密码不符合格式要求，请重新设置");
        return false;
      } else {
        if (this.againPassword !== "") {
          return this.checkAgainPassword(this.password, true);
        }
        return true;
      }
    },
    checkAgainPassword(value, isChange = false) {
      // isChange 是否是checkPassword触发
      if (value === "") {
        this.$toast("请再次输入密码");
        return false;
      } else if (this.password && value != this.password) {
        this.$toast("两次输入密码不一致!");
        return false;
      } else if (
        isChange &&
        this.password &&
        value != this.againPassword
      ) {
        this.$toast("两次输入密码不一致!");
        return false;
      } else {
        return true;
      }
    },
    // 表单检测相关方法结束
    getKeyCode() {
      const self = this;
      // Q4jfE@#!12urt34..qOphfss
      const [c1, c2, c3] = ['Q4jfE@#!', '12ur', 't34..qOphfss'];
      if (this.whetherGetKeyCode) return;
      if (!this.checkPhone(this.username)) return;
      getMCipher({
        phone: this.username
      }).then(res => {
        if (res.appStatus.errorCode == 0) {
          verificationCode({
            phone: self.username,
            type: 1,
            user_type: 1,
            account: self.username,
            rCode: self.$md5(`${c1}${c2}${c3}${res.content.code}`)
          }).then((res) => {
            if (res.appStatus.errorCode == 0) {
              self.whetherGetKeyCode = true;
              self.codeColor = "#999999";
              let time = setInterval(() => {
                if (self.codeTime > 0) {
                  self.codeTime--;
                } else if (self.codeTime == 0) {
                  clearInterval(time);
                  self.codeTime = 60;
                  self.whetherGetKeyCode = false;
                  self.codeColor = "#FF5918";
                }
              }, 1000);
            } else if (res.appStatus.errorCode == 5114) {
              this.showLogin = true;
            }
          });
        }
      });
    },
    // 查看密码
    checkPwd() {
      this.isCheckPwd1 = !this.isCheckPwd1;
    },
    // 查看再次输入的密码
    checkPwd2() {
      this.isCheckPwd2 = !this.isCheckPwd2;
    },
    onSubmit() {
      InfoTwo(
        `sellerTypeId=${1}&account=${this.username}&password=${this.password
        }&confirmPassword=${this.againPassword}&smsCode=${this.code
        }&company=${this.company}&isCfP=${0}&phone=${this.username}`
      ).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.onSubmitLogin();
        }
      });
    },
    onCopy() {
      this.$toast("复制成功");
    },
    onError() {
      this.$toast("复制失败，请重试");
    },
    getActivityRuleContent() {// 获取悦卖用户协议
      getActivityRuleContent({ type: 44 }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.protocolMain = res.content.content;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  overflow: hidden;
}
// 注册相关
.logo {
  margin: 33px 0 49px;
  display: flex;
  justify-content: center;
  img {
    width: 168px;
    height: 42px;
  }
}
.form-main {
  padding: 0 22px;
  .code-btn {
    border: 0px;
    color: #FFB14A!important;
    font-size: 14px;
  }
  .register-btn {
    width: 331px;
    height: 42px;
    background: #FFB14A;
    border-radius: 5px;
    color: #fff;
    border: none;
    margin: 30px auto;
  }
  .check-box {
    padding: 0;
  }
  .check-box::after {
    border: none;
  }
  /deep/.van-checkbox__icon .van-icon {
    line-height: 1.25em;
  }
  .agreement1 {
    font-size: 12px;
    margin-left: 10px;
    color: #989898;
  }
  .agreement2 {
    font-size: 12px;
    color: #0066cc;
  }
}
/deep/.van-overlay {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .wrapper {
    width: 258px;
    height: 352px;
    padding: 21px;
    border-radius: 7px;
    background: #fff;
    overflow: auto;
    span {
      overflow-y: auto;
    }
  }
}
.back-btn {
  width: 345px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  background: #ff5918;
  border-radius: 5px;
  color: #fff;
  font-size: 16px;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  bottom: 15px;
}
.login-wrapper {
  width: 300px;
  height: 280px;
  padding: 30px 25px 20px;
  background-color: #ffffff;
  border-radius: 7px;
}
.login-title {
  margin-bottom: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  text-align: center;
}
.login-btn {
  display: flex;
  justify-content: center;
  margin-top: 43px;
  .cancel {
    width: 125px;
    height: 40px;
    color: #999999;
    background-color: #eeeeee;
    margin-right: 10px;
    border-radius: 5px;
    border: none;
  }
  .confirm {
    width: 125px;
    height: 40px;
    color: #ffffff;
    background-color: #2dc660;
    border-radius: 5px;
    border: none;
  }
}
</style>